import type { User } from "@rowan/prisma";
import { createContext } from "react";

type SettingsContextType = {
  ereaderSettings?: User["ereaderSettings"];
  setEreaderSettings: (settings?: User["ereaderSettings"]) => void;
  settingsOpen?: boolean;
  setSettingsOpen: (open: boolean) => void;
};

export const SettingsContext = createContext<SettingsContextType>({
  setSettingsOpen: () => {},
  setEreaderSettings: () => {},
});
